import React from "react";
import "./LoadingScreen.css";

const LoadingScreen = (props) => {
  return (
    <div className="loadingio-spinner-spinner-5blb229gdn5">
      <div className="ldio-hs7dntj6dvo">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};
export default LoadingScreen;
